import { useParams } from "react-router-dom"

import { UrlPath } from "utility/routes"
import AccessManagement from "./AccessManagement/AccessManagement";
import PhoneNumbers from "./Edit/PhoneNumbers";
import Details from "./Edit/Details";
import Industries from "./Edit/Industries";
import Links from "./Edit/Links";
import MyInvoices from "./Invoices/MyInvoices";
import Logg from "./Logg/Logg";
import Products from "./Products/Products";
import OpeningHours from "./Edit/OpeningHours";
import FormContainer from "components/Form/FormContainer";
import BreadcrumbCompany from "./BreadcrumbCompany";
// import WebshopForm from "./Webshop/WebshopForm";
import SessionKiller from "components/SessionKiller";
import ExtraLinksPromo from "./Webshop/Promo/ExtraLinksPromo";


const EditCompany = () => {
  let params = useParams();
  let editElement:JSX.Element;
  let title:string | undefined;
  let validation:string | undefined;
  
  switch(params.element) {
    case(UrlPath.Account.Actions.Details) :
    default:
      editElement = <Details />
      title = "Endre markedsnavn og adresse";
      validation = UrlPath.Account.Actions.Details;
      break;
    case(UrlPath.Account.Actions.PhoneNumbers) :
      editElement = <PhoneNumbers />
      title = "Endre/legg til telefonnummer";
      validation = UrlPath.Account.Actions.PhoneNumbers;
    break;
    case(UrlPath.Account.Actions.Products) :
    editElement = <Products />
    title = "Mine produkter";
    break;
    case(UrlPath.Account.Actions.Logg) :
    editElement = <Logg />
    title = "Endre lenker";
    break;
    case(UrlPath.Account.Actions.Invoices) :
    editElement = <MyInvoices />
    title = "Se faktura";
    break;
    case(UrlPath.Account.Actions.AccessManagement) :
    editElement = <AccessManagement />
    title = "Endre brukere";
    break;
    case(UrlPath.Account.Actions.Links) :
    editElement = <Links />
    title = "Endre lenker";
    validation = UrlPath.Account.Actions.Links;
    break;
    case(UrlPath.Account.Actions.Industries) :
    editElement = <Industries />
    title = "Endre bransjer";
    validation = UrlPath.Account.Actions.Industries;
    break;
    case(UrlPath.Account.Actions.OpeningHours) :
    editElement = <OpeningHours />
    title = "Endre åpningstider";
    validation = UrlPath.Account.Actions.OpeningHours;
    break;
  }

  return (
    <>
      <BreadcrumbCompany />
      <SessionKiller></SessionKiller>
      <div className="card">
        <div className="card-body">
          <FormContainer validation={validation}>
          <h1 className="h3">{title}</h1>
          <div className="cc-form">
            {editElement}
          </div>
          </FormContainer>
        </div>
      </div>
      {params.element === UrlPath.Account.Actions.Links ? <ExtraLinksPromo/> : null}
    </>
  )
}

export default EditCompany